import React from 'react';
import TransactionsLink from 'components/Links/TransactionsLink';
import Dropdown from 'components/UIKit/Dropdown';

let TransactionTypeFilter = ({
  type,
  isDryRun,
  query,
  state,
  style,
}) => {
  return (
    <span style={style}>
      <span>Type: &nbsp;</span>
      <Dropdown selected={type || 'All'}>
        <TransactionsLink
          query={{ state, isDryRun, ...query, offset: 0 }}
        >
          All
        </TransactionsLink>
        <TransactionsLink
          query={type !== 'upload' ? { ...query, state, isDryRun, type: 'upload', offset: 0 } : { ...query, state, isDryRun }}
        >
          Upload
        </TransactionsLink>
        <TransactionsLink
          query={type !== 'delete' ? { ...query, state, isDryRun, type: 'delete', offset: 0 } : { ...query, state, isDryRun }}
        >
          Delete
        </TransactionsLink>
        <TransactionsLink
          query={type !== 'patch' ? { ...query, state, isDryRun, type: 'patch', offset: 0 } : { ...query, state, isDryRun }}
        >
          Patch
        </TransactionsLink>
        <TransactionsLink
          query={type !== 'open' ? { ...query, state, isDryRun, type: 'open', offset: 0 } : { ...query, state, isDryRun }}
        >
          Open
        </TransactionsLink>
        <TransactionsLink
          query={type !== 'review' ? { ...query, state, isDryRun, type: 'review', offset: 0 } : { ...query, state, isDryRun }}
        >
          Review
        </TransactionsLink>
        <TransactionsLink
          query={type !== 'release' ? { ...query, state, isDryRun, type: 'release', offset: 0 } : { ...query, state, isDryRun }}
        >
          Release
        </TransactionsLink>
        <TransactionsLink
          query={type !== 'submit' ? { ...query, state, isDryRun, type: 'submit', offset: 0 } : { ...query, state, isDryRun }}
        >
          Submit
        </TransactionsLink>
        <TransactionsLink
          query={type !== 'batch_submit' ? { ...query, state, isDryRun, type: 'batch_submit', offset: 0 } : { ...query, state, isDryRun }}
        >
          Batch_submit
        </TransactionsLink>
        <TransactionsLink
          query={type !== 'batch_release' ? { ...query, state, isDryRun, type: 'batch_release', offset: 0 } : { ...query, state, isDryRun }}
        >
          Batch_release
        </TransactionsLink>
      </Dropdown>
    </span>
  );
};

export default TransactionTypeFilter;
